export default class StripeSessionView
{
	id = null
	sessionId = null
	userId = null
	createdOn = null
	
	lastUpdatedOn = null

	status = null
	payment_status = null

	product = {}
}